module.exports = __webpack_public_path__ + "img/ico_voucher-accent.1e312467.svg";